import type {NextRouter} from 'next/router';

export class RouterHolder {
  static router: NextRouter;
}
